<nav class="navbar navbar-primary bg-primary">
    <span class="navbar-text">
     ICT Notes
    </span>
</nav>
<div class="row">

  <div class="col-sm">
    <img src="https://cdn.pixabay.com/photo/2020/04/30/17/50/network-5113917_960_720.jpg" alt="Italian Trulli">
   
  </div>
  <div class="col-sm">
    <img src="https://cdn.pixabay.com/photo/2019/08/26/05/21/network-4430786_960_720.jpg" alt="Italian Trulli">
         </div>
  <div class="col-sm">
    <img src="https://d205s6oy6l2xs9.cloudfront.net/wp-content/uploads/20200630140652/artificial-intelligence-3382507_1280.jpg" alt="Italian Trulli">
  </div>
  <div class="col-sm">
    <img src="https://cdn.pixabay.com/photo/2020/04/30/17/50/network-5113917_960_720.jpg" alt="Italian Trulli">
  </div>
</div>

<div class="table-responsive-sm">
<table class="table table-primary" style="float:left">
    <thead>
      <tr>
        <th *ngFor ="let header of headers">{{header.label}}</th>
                  
       </tr>
    </thead>
    <tbody>
      <tr *ngFor = "let record of data">
       <td *ngFor = "let header of headers" >
        <a [href]="record.link" mat-raised-button color='accent'>
            {{record[header.key]}}
        </a>
        </td>
      </tr>          
    </tbody>
  </table>
</div>
